export default __webpack_public_path__ + "moin-app-illus-no-notification-muted.023cbfa9cf64cfcfcaeb9329a649f188.png";